/** @format */

export const DEFAULT_TEST_ID = 'timeline-marker';
